import React from "react";
import "./Accessibility.css";

const AccessibilityPanel = ({ open, children, onClose }) => {

    return (

        <aside className={`a11y-panel ${open ? "open" : ""}`}>

            <div className="a11y-header">

                <h2>Site Settings</h2>

                <button onClick={onClose}>

                    ✕

                </button>

            </div>

            <div className="a11y-content">

                {children}

            </div>

        </aside>

    );

};

export default AccessibilityPanel;